exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{height:100%;margin:0;padding:0;overflow:hidden}.editor{width:100%;height:100%;display:flex;flex-direction:column}.editor-header{width:100%;flex:none}.editor-container{flex:auto;overflow:auto}.editor-header{border-bottom:1px solid #999}.editor-bar{display:flex;align-items:center;flex-wrap:wrap;justify-content:space-between}.editor-title{flex:none;margin:5px}.editor-menu{flex:auto;margin:5px}input[type=range]{display:inline-block;margin-left:1em;width:10em;vertical-align:middle}.slider-label{display:inline-block;margin:auto}.slider-input{height:1em}.board-border{stroke-width:1;stroke:#000;fill:none}.board-grid{stroke-width:1;stroke:#c8c8c8}.field-filled{fill:#00f;stroke-width:0;stroke:#000}.field-empty{fill:#fff;stroke-width:0;stroke:#000}#app-container{height:100%}body{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#f8f8f8}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/app.css
 ** module id = 88
 ** module chunks = 0
 **/